

<ng-container *ngIf="state">

  <app-modal-header
    (close)="close()">

    <ng-container *ngIf="state.fetchingUser$ | async">
      <p-skeleton width="12rem" height="2rem"></p-skeleton>
      <p-skeleton width="7.5rem" height="1rem" class="mt-3 block"></p-skeleton>
    </ng-container>

    <ng-container *ngIf="(state.customerCard$ | async) as c" slot="title">
      <ng-container *ngIf="c.user">
        <p class="m-0">
          {{ c.user.orgUsers | userNameOrEmail:selectedOrg.getCurrentValue():true }}
        </p>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(state.customerCard$ | async) as c">
      <ng-container *ngIf="c.user">
        <p class="m-0 text-color-secondary">
          {{ c.user.email }}
        </p>
      </ng-container>
    </ng-container>

  </app-modal-header>
  

  <p-tabView [activeIndex]="activeTabIndex" (activeIndexChange)="onTabChange($event)">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>
          {{ 'admin.lecturer-customer-card-modal.tab.customer.label' | translate }}
        </span>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel >
      <ng-template pTemplate="header">
        <span>
          {{ 'admin.lecturer-customer-card-modal.tab.attendance.label' | translate }}
        </span>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
  
  <div class="modal-body flex flex-column modal-body--highlighted">
    
    <!-- CUSTOMER -->
    <ng-container *ngIf="activeTabIndex === 0">
      <ng-container *ngTemplateOutlet="customer"></ng-container>
    </ng-container>
    <!-- / -->

    <!-- ATTENDANCE -->
    <ng-container *ngIf="activeTabIndex === 1">
      <ng-container *ngTemplateOutlet="attendanceEl"></ng-container>
    </ng-container>
    <!-- / -->
  
  </div>

  
  
  
  
  <ng-template #customer>

    <app-customer-card-customer [disableControls]="true"></app-customer-card-customer>
  
  </ng-template>


  <ng-template #attendanceEl>

    <app-customer-card-attendance></app-customer-card-attendance>

  </ng-template>
  
  


</ng-container>
